export const toAbsoluteUrl = (path) => {
    if (!path || !path.trim())
        return null;
    try {
        let url;
        if (path.startsWith('http')) {
            url = new URL(path);
        }
        else if (path.startsWith('/')) {
            if (typeof window === 'undefined')
                return null;
            url = new URL(path, window.location.origin);
        }
        else {
            if (typeof window === 'undefined')
                return null;
            const protocol = window.location.protocol || 'https:';
            url = new URL(`${protocol}//${path}`);
        }
        if (url.protocol !== 'https:') {
            console.warn('[toAbsoluteUrl] Blocked non-HTTP(S) URL:', url.toString());
            return null;
        }
        return url.toString();
    }
    catch {
        console.warn('[toAbsoluteUrl] Invalid URL:', path);
        return null;
    }
};
export const toRelativeUrl = (urlString) => {
    if (typeof urlString !== 'string') {
        return null;
    }
    if (!urlString.trim().length) {
        return null;
    }
    try {
        const absoluteUrl = new URL(urlString);
        const { pathname, search, hash } = absoluteUrl;
        return `${pathname}${search}${hash}`;
    }
    catch (e) {
        return urlString;
    }
};
export const addSearchParam = (url, key, value = '') => {
    try {
        const fullUrl = url.startsWith('http')
            ? url
            : new URL(url, window.location.origin).toString();
        const parsed = new URL(fullUrl);
        parsed.searchParams.set(key, value);
        return parsed.toString();
    }
    catch (e) {
        console.error('addSearchParam error', url, e);
        return url;
    }
};
export const removeCurrentSearchParams = (params) => {
    const url = new URL(window.location.href);
    if (!params || params.length <= 0) {
        return;
    }
    params.forEach((param) => {
        url.searchParams.delete(param);
    });
    history.replaceState(null, '', url.toString());
};
export const urlOrigin = (url) => {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.origin;
    }
    catch (e) {
        console.error('Invalid URL:', url, e);
        return null;
    }
};
export const normalizeURL = (url) => new URL(url).toString();
export const redirect = (redirectionUrl) => {
    if (typeof window === 'undefined')
        return;
    const currentUrl = window.location.href;
    const absoluteRedirectionUrl = toAbsoluteUrl(redirectionUrl) ?? currentUrl;
    const normalizedCurrent = normalizeURL(currentUrl);
    const normalizedTarget = normalizeURL(absoluteRedirectionUrl);
    const currentOrigin = urlOrigin(currentUrl);
    const targetOrigin = urlOrigin(absoluteRedirectionUrl);
    /*
      Prevent redirects to a different origin to avoid
      open redirect vulnerabilities and potential phishing attacks.
    */
    if (currentOrigin && currentOrigin !== targetOrigin) {
        console.warn('[redirect] Redirect URL origin mismatch; redirect aborted.');
        window.location.href = currentOrigin;
        return;
    }
    if (normalizedTarget === normalizedCurrent) {
        console.warn('[redirect] Reloading same URL');
        window.location.reload();
        return;
    }
    window.location.href = normalizedTarget;
};
export const redirectAction = (redirectUrl) => {
    if (hasSameOrigin(redirectUrl)) {
        window.location.href = redirectUrl;
    }
    else {
        console.warn(`Redirect blocked for URL: ${redirectUrl} due to illegal origin`);
    }
};
const hasSameOrigin = (urlToCheck) => {
    try {
        const currentOrigin = window.location.origin;
        const url = new URL(urlToCheck, currentOrigin);
        return url.origin === currentOrigin;
    }
    catch {
        return false;
    }
};
export const googleAuthRedirection = (rawRedirect) => {
    if (!rawRedirect)
        return '/';
    const absoluteUrl = toAbsoluteUrl(rawRedirect);
    if (absoluteUrl && urlOrigin(absoluteUrl) === window.location.origin) {
        return absoluteUrl;
    }
    console.warn('[useSendGoogleTracking] blocked unsafe redirect:', rawRedirect);
    return '/';
};
//# sourceMappingURL=url.js.map